var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Controls"},[_c('span',{staticStyle:{"color":"#008cee"},on:{"click":function($event){return _vm.toOther(_vm.value.value)}}},[_vm._v(_vm._s(_vm.value.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }